import React, { createContext, useState, useContext, useEffect } from "react";
import { useHttpClient } from "../hooks/http-hook";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authData, setAuthData] = useState({
    userId: null,
    role: null,
    isLoggedIn: false,
  });
  const [isAuthChecked, setIsAuthChecked] = useState(false);

  const { sendRequest } = useHttpClient();

  const setAuth = (userId, role, isLoggedIn) => {
    setAuthData({
      userId,
      role,
      isLoggedIn,
    });
  };

  /**
   * Check if the user is authenticated
   * and set the auth state accordingly
   */
  const checkAuthStatus = async () => {
    try {
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}auth/check-status`,
        "GET",
        null,
        {
          "Content-Type": "application/json",
        }
      );

      if (response) {
        setAuth(response._id, response.role, true);
      }
    } catch (err) {
      console.error("Failed to check auth status:", err);
      setAuth(null, null, false);
    } finally {
      setIsAuthChecked(true);
    }
  };

  useEffect(() => {
    checkAuthStatus();
  }, [sendRequest]);

  return (
    <AuthContext.Provider value={{ authData, setAuth, isAuthChecked }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
